import script from "./BaseTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTable.vue?vue&type=script&setup=true&lang=js"

import "./BaseTable.vue?vue&type=style&index=0&id=7d15c9c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d15c9c0"]])

export default __exports__